var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":_vm.changeSortValue}},[_vm._v(" "+_vm._s(_vm.$t(_vm.item.label))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }